import { render } from "./PageSorular.vue?vue&type=template&id=1362d5e6"
import script from "./PageSorular.vue?vue&type=script&lang=js"
export * from "./PageSorular.vue?vue&type=script&lang=js"
script.render = render

export default script